import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SUMMARY_DIMENSIONS } from './constants';

export const popoverStyles = css`
  width: 320px;
  max-height: 351px;
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid ${theme.colors.neutral10};
  background: ${theme.colors.white};
  padding: 0;
`;

export const contentStyles = css`
  padding: ${theme.spacing(2, 2, 1)};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
`;

export const errorStyles = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;

export const skeletonContainerStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(0.55)};
  max-width: ${SUMMARY_DIMENSIONS.WIDTH}px;
  max-height: ${SUMMARY_DIMENSIONS.HEIGHT}px;
`;

export const summaryTextStyles = css`
  max-width: ${SUMMARY_DIMENSIONS.WIDTH}px;
  max-height: ${SUMMARY_DIMENSIONS.HEIGHT}px;
  overflow: auto;
  color: ${theme.colors.neutral80};
  word-wrap: break-word;
  margin-bottom: ${theme.spacing(1)};
  padding-left: ${theme.spacing(2)};
  border-left: 1px solid ${theme.colors.neutral10};
`;

export const aiChipContainerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const aiChipStyles = css`
  background: linear-gradient(135deg, #dcebfe 0%, #e0faf8 100%);
  border: none;
  color: ${theme.colors.neutral70};
  padding: ${theme.spacing(0, 0.5)};
  max-width: 164px;

  svg {
    fill: ${theme.colors.neutral70};
  }
`;

export const feedbackSectionStyles = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
  padding-top: ${theme.spacing(1)};
  margin-left: -${theme.spacing(2)};
  margin-right: -${theme.spacing(2)};
  border-top: 1px solid ${theme.colors.neutral10};
`;

export const feedbackButtonStyles = css`
  padding: ${theme.spacing(0.3)};
  min-width: 24px;
  height: 24px;
`;

export const textStyles = {
  fontSize: theme.fontSize(14),
  backgroundImage: `linear-gradient(45deg, ${theme.colorsV2.tangerine50()} 0%, ${theme.colorsV2.eggplant50()} 50%, ${theme.colorsV2.seaweed50()} 100%)`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
};
